<template>
  <v-container>
    <v-row justify="center" class="mt-0">
      <v-col
        cols="12"
        class="py-0"
        width="100%"
      >
        <v-card
          class="pa-4 helmi-card"
        >
          <div class="helmi-card-title pl-2 pt-2">
            Oma profiili
          </div>
          <v-form
            ref="profile"
            v-model="profileValid"
          >
            <v-card-text class="pt-5">
              <v-row>
                <v-col
                  sm="8"
                  cols="12"
                  class="pr-4 pl-1 pt-5 pb-1"
                >
                  <v-row>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="userDetails.email"
                        label="Käyttäjätunnus"
                        disabled
                        outlined
                      />
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="name"
                        :rules="rules"
                        label="Nimi"
                        outlined
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="title"
                        :rules="rules"
                        label="Asema"
                        outlined
                      />
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="phone"
                        :rules="rules"
                        label="Puhelin"
                        outlined
                      />
                    </v-col>
                  </v-row>
                  <v-col class="px-0">
                    <v-select
                      v-model="emailNotifications"
                      :items="notificationItems"
                      return-value
                      label="Kalenteritapahtumat sähköpostiin"
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col class="px-0">
                    <v-select
                      v-model="buyerNotifications"
                      :items="notificationItems"
                      return-value
                      label="Automaattiset asiakasmuistutukset"
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col class="px-0">
                    <v-select
                      v-model="defaultView"
                      :items="defaultViewItems"
                      return-value
                      label="Oletusnäkymä"
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col class="px-0">
                    <v-select
                      v-model="defaultSide"
                      :items="defaultSideItems"
                      return-value
                      label="Oletuspuoli"
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col class="px-0">
                    <v-textarea
                      v-model="description"
                      :rules="rules"
                      label="Kuvaus"
                      rows="4"
                      outlined
                    />
                  </v-col>
                  <v-row
                    justify="end"
                    class="gap mx-0 mb-0"
                    :class="$vuetify.breakpoint.xs ? 'reverse' : ''"
                  >
                    <v-btn
                      color="primary"
                      depressed
                      outlined
                      @click="passwordModal = true"
                    >
                      Vaihda salasana
                    </v-btn>
                    <v-btn
                      color="primary"
                      depressed
                      :disabled="!profileValid"
                      :loading="loadingAgent"
                      @click="save()"
                    >
                      Tallenna
                    </v-btn>
                  </v-row>
                </v-col>

                <v-col
                  sm="4"
                  cols="12"
                  class="py-2"
                  :class="$vuetify.breakpoint.xs ? 'px-5' : 'px-3'"
                >
                  <div :class="$vuetify.breakpoint.xs ? 'px-5 pb-4' : 'px-7'">
                    <v-img
                      :src="image"
                      contain
                      style="width: 100%"
                    />

                    <v-row justify="center" class="mt-4">
                      <v-btn
                        rounded
                        outlined
                        color="primary"
                        :loading="loadingImage"
                        @click="onPickFile"
                      >
                        Vaihda kuva
                      </v-btn>
                    </v-row>
                    <input
                      ref="fileInput"
                      accept="image/*"
                      style="display: none;"
                      type="file"
                      @change="onFilePicked"
                    >
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="messageBox"
      color="green"
    >
      Välittäjän tiedot päivitetty
    </v-snackbar>

    <v-snackbar
      v-model="passwordChanged"
      color="green"
    >
      Salasana vaihdettu onnistuneesti
    </v-snackbar>

    <v-dialog
      v-model="passwordModal"
      persistent
      max-width="400"
    >
      <v-form v-model="passwordValid">
        <v-card>
          <div class="helmi-card-title pl-4 pt-3">
            Vaihda salasana
          </div>
          <v-card-text class="pb-0 pt-3">
            <v-text-field
              v-model="password"
              :rules="passwordRules"
              label="Uusi salasana"
              type="password"
              outlined
            />
            <v-text-field
              v-model="passwordAgain"
              :rules="passwordMatch"
              label="Uusi salasana uudelleen"
              type="password"
              outlined
            />
          </v-card-text>
          <v-card-actions class="pb-4 pr-4">
            <v-spacer/>
            <v-btn
              text
              @click="passwordModal = false"
            >
              Peruuta
            </v-btn>
            <v-btn
              color="primary"
              text
              :disabled="!passwordValid"
              :loading="loadingPassword"
              @click="updatePassword()"
            >
              Lähetä
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { readAndCompressImage } from 'browser-image-resizer';
import axios from 'axios';
import { apiPost } from '@/api';

export default {
  data: () => ({
    messageBox: false,
    passwordChanged: false,
    loadingPassword: false,
    passwordValid: false,
    config: {
      quality: 0.85,
      maxWidth: 1100,
      maxHeight: 1100,
    },
    rules: [value => !!value || 'Pakollinen kenttä.'],
    passwordRules: [(value) => {
      const smallLetters = /[a-z]/;
      if (!smallLetters.test(value)) {
        return 'Salasanassa pitää olla vähintään yksi pieni kirjain';
      }

      const bigLetters = /[A-Z]/;
      if (!bigLetters.test(value)) {
        return 'Salasanassa pitää olla vähintään yksi iso kirjain';
      }

      const numbers = /[0-9]/;
      if (!numbers.test(value)) {
        return 'Salasanassa pitää olla vähintään yksi numero';
      }

      if (value.length < 6) {
        return 'Salasanassa pitää olla vähintään 6 merkkiä.';
      }

      return true;
    }],
    axios,
    passwordModal: false,
    profileValid: false,
    password: '',
    passwordAgain: '',
    name: '',
    title: '',
    phone: '',
    description: '',
    image: '',
    newImage: null,
    loadingImage: false,
    loadingAgent: false,
    emailNotifications: '0',
    buyerNotifications: '0',
    notificationItems: [
      {
        text: 'Käytössä',
        value: '0',
      },
      {
        text: 'Ei käytössä',
        value: '1',
      },
    ],
    defaultViewItems: [
      {
        text: 'Kaikkien kohteet',
        value: '0',
      },
      {
        text: 'Omat kohteet',
        value: '1',
      },
    ],
    defaultSideItems: [
      {
        text: 'Myyntikohteet',
        value: '0',
      },
      {
        text: 'Vuokrakohteet',
        value: '1',
      },
    ],
    defaultView: '0',
    defaultSide: '0',
  }),
  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
    passwordMatch() {
      return [this.passwordAgain === this.password || 'Salasanat eivät täsmää'];
    },

    breadCrumbs() {
      return [
        {
          disabled: false,
          link: false,
          text: 'Profiili',
        }];
    },
  },
  watch: {
    userDetails: {
      handler() {
        this.name = this.userDetails.nimi;
        this.title = this.userDetails.asema;
        this.phone = this.userDetails.puhelin;
        this.description = this.userDetails.kuvaus;
        this.image = this.userDetails.image;
        this.emailNotifications = this.userDetails.kalenteritapahtumat;
        this.buyerNotifications = this.userDetails.buyerNotifications;
        this.defaultView = this.userDetails.defaultView;
        this.defaultSide = this.userDetails.defaultSide;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      setAuthorization: 'setAuthorization',
      loadAgent: 'loadAgent',
    }),
    async save() {
      this.loadingAgent = true;
      const params = {
        name: this.name.trim(),
        title: this.title.trim(),
        phone: this.phone.trim(),
        description: this.description.trim(),
        emailNotifications: this.emailNotifications,
        buyerNotifications: this.buyerNotifications,
        defaultView: this.defaultView,
        defaultSide: this.defaultSide,
      };

      const result = await apiPost('agent/update', params);
      if (result.success) {
        this.messageBox = true;
      }

      await this.loadAgent();
      this.loadingAgent = false;
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    async updatePassword() {
      this.loadingPassword = true;
      const result = await apiPost('agent/update-password', { password: this.password });
      if (result.success) {
        this.passwordChanged = true;
      }
      this.passwordModal = false;
      this.loadingPassword = false;
    },
    async onFilePicked(event) {
      this.loadingImage = true;
      const { files } = event.target;
      const resizedImage = await readAndCompressImage(files[0], this.config);
      const resizedFile = new File(
        [resizedImage],
        files[0].name, {
          type: files[0].type,
          lastModified: Date.now(),
        },
      );

      const formData = new FormData();
      formData.append('images[]', resizedFile);

      this.axios.post(process.env.NODE_ENV === 'production'
        ? '/public/backend/api/v1/agent/image-upload'
        : 'http://localhost:8888/public/backend/api/v1/agent/image-upload',
      formData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async (data) => {
        console.log(data);
        await this.loadAgent();
        this.loadingImage = false;
      })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
  .gap {
    gap: 8px;
  }

  .reverse {
    flex-direction: column-reverse;
  }
</style>
